import React, { useState, useEffect } from 'react';
import { Box, Divider, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import ToggleList from '../components/ToggleList';
import { fetchQuestionsHandler } from '../ResponseHandlers/fetchQuestionsHandler';
import FragenPage from './FragenPage';
import InProgress from '../components/InProgress';

const StatePage = () => {
    const [questions, setQuestions] = useState([]);
    const [loading, setLoading] = useState(false);

    const handleConfirm = async (selectedOption) => {
        // alert(selectedOption);
        try {
            setLoading(true);
            const response = await fetchQuestionsHandler({
                selectedOption,
                usedPage: 'StatePage',
            });
            // const data = await response.json();
            setQuestions(response);
        } catch (error) {
            console.error('Failed to fetch State Questions:', error);
        } finally {
            setLoading(false);
        }
    };

    // Window scroll control (better to use useEffect)
    useEffect(() => {
        const mainElement = document.querySelector('#app-main'); // Locate the window where scroll works
        if (mainElement) {
            mainElement.scrollTo({ top: 0, behavior: 'auto' });
        } else {
            // Fallback to window if container not found
            window.scrollTo({ top: 0, behavior: 'auto' });
        }
    }, []);

    return (
        <Box sx={{ p: 3, textAlign: 'center' }}>
            <Grid container spacing={2}>
                {/* Left: ToggleList */}
                <Grid xs={12} md={6}>
                    <ToggleList onConfirm={handleConfirm} />
                </Grid>
            </Grid>

            <Divider sx={{ my: 4 }} />

            {/* Questions Section */}
            <Box>
                <Typography variant="h5" sx={{ mb: 2 }}>
                    Fragen
                </Typography>
                {questions.length > 0 ? (
                    <FragenPage questions={questions} />
                ) : loading ? (
                    <InProgress />
                ) : (
                    <Typography variant="body1">
                        Bitte wählen Sie einen Bundesland aus, um Fragen zu
                        laden.
                    </Typography>
                )}
            </Box>
        </Box>
    );
};

export default StatePage;
